import React, { useCallback, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import AddToCartModal from '../components/AddToCartModal';
import { GenericErrorModal } from '../components/GenericErrorModal';
import LoginModal from '../components/LoginModal';
import { SaveCopyModal } from '../components/SaveCopyModal';
import {
  LoginModalConfig,
  SHOW_ADD_TO_CART_MODAL,
  SHOW_COPY_PROJECT_NAME_MODAL,
  SHOW_DELETE_SAVED_LAYOUT_MODAL,
  SHOW_GENERIC_ERROR_MODAL,
  SHOW_LEAVE_PROJECT_MODAL,
  SHOW_LOGIN_MODAL,
  SHOW_PROJECT_NAME_MODAL,
  SHOW_SAVE_LAYOUT_MODAL,
  SHOW_SHARE_PROJECT_MODAL,
  hideModal,
} from '../ducks/modals';
import { ProjectDetailsModal } from '../components/ProjectDetailsModal';
import { LeaveProjectModal } from '../components/LeaveProjectModal';
import { ShareProjectModal } from '../components/ShareProjectModal';
import { SaveLayoutModal } from '../components/SaveLayoutModal';
import { DeleteSavedLayoutModal } from '../components/DeleteSavedLayoutModal';

export function ModalContainer() {
  const modal = useSelector((state) => state.modals);
  const modalType = modal?.get('type');
  const dispatch = useDispatch();
  const onHide = useCallback(() => {
    dispatch(hideModal({ hard: false }));
  }, [dispatch]);
  const show = useMemo(() => modal.get('showmodal'), [modal]);
  switch (modalType) {
    case SHOW_ADD_TO_CART_MODAL: {
      return <AddToCartModal show={show} />;
    }
    case SHOW_LOGIN_MODAL: {
      const config = LoginModalConfig.parse(modal.get('config').toJS());
      return <LoginModal show={show} config={config} />;
    }
    case SHOW_COPY_PROJECT_NAME_MODAL: {
      return <SaveCopyModal show={show} onHide={onHide} />;
    }
    case SHOW_GENERIC_ERROR_MODAL: {
      return <GenericErrorModal show={show} onHide={onHide} />;
    }
    case SHOW_PROJECT_NAME_MODAL: {
      return <ProjectDetailsModal show={show} onHide={onHide} />;
    }
    case SHOW_LEAVE_PROJECT_MODAL: {
      return <LeaveProjectModal show={show} onHide={onHide} />;
    }
    case SHOW_SHARE_PROJECT_MODAL: {
      return (
        <ShareProjectModal
          show={show}
          shareID={modal.get('shareID')}
          onHide={onHide}
        />
      );
    }
    case SHOW_SAVE_LAYOUT_MODAL: {
      return <SaveLayoutModal show={show} onHide={onHide} />;
    }
    case SHOW_DELETE_SAVED_LAYOUT_MODAL: {
      return <DeleteSavedLayoutModal show={show} onHide={onHide} />;
    }
  }
}
